module.exports = __webpack_public_path__ + "img/navbar_hoverMenu_2_2.1508d6de.png";